import { isDateInPast } from 'src/functions/date';

function isMessageOutdated(messageDate: string, lastMessageDate: Date) {
	if (!messageDate) return false;

	const dateToTest = new Date(messageDate);

	return isDateInPast(dateToTest, lastMessageDate);
}

export { isMessageOutdated };
